import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  footerNote: {
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    textAlign: 'center',
    margin: 0,
  },
}))

export default useStyles
